import React from 'react'
import PropTypes from 'prop-types'
import { YoutubeVideo } from '../components'

const LessonMediaContent = ({ lesson }) => (
  <div className="flex-column width-full">
    {
      lesson.youtubeVideo &&
      <YoutubeVideo videoUrl={lesson.youtubeVideo} />
    }
    {
      lesson.prologueText &&
      <pre>{lesson.prologueText}</pre>
    }
  </div>
)

LessonMediaContent.propTypes = {
  lesson: PropTypes.object.isRequired,
}

export default LessonMediaContent



// WEBPACK FOOTER //
// ./src/browser/components/LessonMediaContent.js